__turbopack_context__.v({
  "actions": "Image-module__6AgG_q__actions",
  "btnClose": "Image-module__6AgG_q__btnClose",
  "container": "Image-module__6AgG_q__container",
});
